export default [
  {
    name: 'Mod. Facturación',
    icon: 'mdi-calculator',
    path: '/admin/facturacion',
    component: () =>
      import(/* webpackChunkName: "admin-billing" */ './views/BillingAdminInvoiceSales'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
];
